// extracted by mini-css-extract-plugin
export default {"head":"head_head__RZitE","link":"head_link__7hWXt","title":"head_title__crklQ"};